import { v4 as uuidv4 } from 'uuid';


export const doOption = [
    { value: 'پنهان کردن', label: 'پنهان کردن' },
    { value: 'نشان دادن', label: 'نشان دادن' },
    { value: 'پنهان کردن چندگانه', label: 'پنهان کردن چندگانه' },
    { value: 'نمایش چندگانه', label: 'نمایش چندگانه' },
]


export const doOptionUpdateAndCalculate = [
    { value: 'کپی مقدار فیلد', label: 'کپی مقدار فیلد' },
    { value: 'چندین مقدار فیلد را کپی کنید', label: 'چندین مقدار فیلد را کپی کنید' },
    { value: 'محاسبه مقدار فیلد', label: 'محاسبه مقدار فیلد' },
]


export const doOptionEnableAndRequire = [
    { value: 'لازم بودن', label: 'لازم بودن' },
    { value: 'مورد نیاز نیست', label: 'مورد نیاز نیست' },
    { value: "نیاز به چندین گزینه", label: "نیاز به چندین گزینه" },
    { value: "نیاز به چندین گزینه نداشته باشید", label: "نیاز به چندین گزینه نداشته باشید" },
    { value: 'غیر فعال کردن', label: 'غیر فعال کردن' },
    { value: 'فعال کردن', label: 'فعال کردن' },
    { value: 'ماسک را تنظیم کنید', label: 'ماسک را تنظیم کنید' },
]


export const doOptionSkip = [
    { value: 'پرش به صفحه', label: 'پرش به صفحه' },
    { value: 'پنهان کردن صفحه', label: 'پنهان کردن صفحه' },
]


export const doOptionThankYou = [
    { value: 'نمایش پیام سفارشی', label: 'نمایش پیام سفارشی' },
    { value: "هدایت به URL", label: "هدایت به URL" },
]

export const doOptionEmail = [
    { value: 'پاسخگوی خودکار 1', label: 'پاسخگوی خودکار 1' },
]

export const pageOption = [
    { value: 'صفحه 1', label: 'صفحه 1' },
]


export const targetStatus = [
    { value: 'مقدار', label: 'مقدار' },
    { value: 'یک فیلد دیگر', label: 'یک فیلد دیگر' },
]


export const defaultValues = [

    { id: uuidv4(), name: 'ifCondition', value: '' },
    { id: uuidv4(), name: 'ifConditionUpdateAndCalculate', value: '' },
    { id: uuidv4(), name: 'ifConditionEnableAndRequire', value: '' },
    { id: uuidv4(), name: 'ifConditionThankYou', value: '' },
    { id: uuidv4(), name: 'ifConditionSkip', value: '' },
    { id: uuidv4(), name: 'ifConditionEmail', value: '' },
    { id: uuidv4(), name: 'StateCondition', value: '' },
    { id: uuidv4(), name: 'StateConditionUpdateAndCalculate', value: '' },
    { id: uuidv4(), name: 'StateConditionEnableAndRequire', value: '' },
    { id: uuidv4(), name: 'StateConditionThankYou', value: '' },
    { id: uuidv4(), name: 'StateConditionSkip', value: '' },
    { id: uuidv4(), name: 'StateConditionEmail', value: '' },
    { id: uuidv4(), name: 'valueCondition', value: '' },
    { id: uuidv4(), name: 'valueConditionUpdateAndCalculate', value: '' },
    { id: uuidv4(), name: 'valueConditionEnableAndRequire', value: '' },
    { id: uuidv4(), name: 'valueConditionThankYou', value: '' },
    { id: uuidv4(), name: 'valueConditionSkip', value: '' },
    { id: uuidv4(), name: 'valueConditionEmail', value: '' },
    { id: uuidv4(), name: 'DoCondition', value: '' },
    { id: uuidv4(), name: 'DoConditionUpdateAndCalculate', value: '' },
    { id: uuidv4(), name: 'DoConditionEnableAndRequire', value: '' },
    { id: uuidv4(), name: 'DoConditionThankYou', value: '' },
    { id: uuidv4(), name: 'DoConditionSkip', value: '' },
    { id: uuidv4(), name: 'DoConditionEmail', value: '' },
    { id: uuidv4(), name: 'FieldCondition', value: '' },
    { id: uuidv4(), name: 'FieldConditionUpdateAndCalculate', value: '' },
    { id: uuidv4(), name: 'FieldConditionEnableAndRequire', value: '' },
    { id: uuidv4(), name: 'TargetStatus', value: null },
    { id: uuidv4(), name: 'TargetStatusUpdateAndCalculate', value: null },
    { id: uuidv4(), name: 'TargetStatusEnableAndRequire', value: null },
    { id: uuidv4(), name: 'TargetStatusThankYou', value: null },
    { id: uuidv4(), name: 'TargetStatusSkip', value: null },
    { id: uuidv4(), name: 'TargetStatusEmail', value: null },
    { id: uuidv4(), name: 'ifFieldCondition', value: null },
    { id: uuidv4(), name: 'ifFieldConditionUpdateAndCalculate', value: null },
    { id: uuidv4(), name: 'ifFieldConditionEnableAndRequire', value: null },
    { id: uuidv4(), name: 'ifFieldConditionThankYou', value: null },
    { id: uuidv4(), name: 'valueEnableAndRequire', value: '' },
    { id: uuidv4(), name: 'urlValue', value: '' },
    { id: uuidv4(), name: 'emailValue', value: '' },
    { id: uuidv4(), name: 'editorValue', value: '' },
    { id: uuidv4(), name: 'fromValue', value: '' },
    { id: uuidv4(), name: 'toValue', value: '' },
    { id: uuidv4(), name: 'summaryValue', value: '' },
    { id: uuidv4(), name: 'FinalThankYouContent', value: '' },
    { id: uuidv4(), name: 'CalculateValue', value: '' },
];